var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pwfvjv3a4a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.664862 0 0 0 0 0.688555 0 0 0 0 0.705786 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pwfvjv3a4a)",
    transform: "translate(-298 -23) translate(240) translate(26)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.547 0c1.178 0 2.174.794 2.48 1.875H15c.388 0 .703.315.703.703v.703h3.281c1.163 0 2.11.947 2.11 2.11v16.5c0 1.163-.947 2.109-2.11 2.109H2.11C.946 24 0 23.054 0 21.89V5.39c0-1.162.946-2.109 2.11-2.109h3.28v-.703c0-.388.315-.703.704-.703h1.972C8.373.794 9.37 0 10.546 0zM2.812 4.688H2.11c-.387 0-.703.315-.703.703v16.5c0 .387.316.703.703.703h16.875c.388 0 .703-.316.703-.703V5.39c0-.388-.315-.704-.703-.704h-.703v15.797c0 .389-.315.703-.703.703H3.516c-.389 0-.704-.314-.704-.703V4.687zm2.579 0H4.219V19.78h12.656V4.688h-1.172v.703c0 .388-.315.703-.703.703H6.094c-.389 0-.703-.315-.703-.703v-.704zm3.093 10.828c.389 0 .704.314.704.703 0 .388-.315.703-.704.703H6.328c-.388 0-.703-.315-.703-.703 0-.389.315-.703.703-.703zm5.784-1.904c.275-.274.72-.274.995 0 .274.275.274.72 0 .995l-2.11 2.109c-.137.137-.317.206-.497.206s-.36-.069-.497-.206l-1.172-1.172c-.274-.275-.274-.72 0-.994.275-.275.72-.275.995 0l.674.674zm-5.784-3.487c.389 0 .704.315.704.703 0 .388-.315.703-.704.703H6.328c-.388 0-.703-.315-.703-.703 0-.388.315-.703.703-.703zm5.784-1.903c.275-.275.72-.275.995 0 .274.274.274.72 0 .994l-2.11 2.11c-.137.137-.317.205-.497.205s-.36-.068-.497-.206l-1.172-1.172c-.274-.274-.274-.72 0-.994.275-.275.72-.275.995 0l.674.675zm-3.721-6.816c-.646 0-1.172.526-1.172 1.172 0 .388-.315.703-.703.703H6.797v1.406h7.5V3.282h-1.875c-.388 0-.703-.315-.703-.703 0-.646-.526-1.172-1.172-1.172z",
    transform: "translate(32 23)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.30fb82cee13515d65285793a9bc3f5c3.svg";
export { ForwardRef as ReactComponent };